import _createMediaLoader from "./createMediaLoader";
import _createFileLoader from "./createFileLoader";
import _loadImage from "./loadImage";
var exports = {};
const createMediaLoader = _createMediaLoader;
const createFileLoader = _createFileLoader;
const loadImage = _loadImage;
exports = [// json
{
  key: "json",
  match: /\.json$/i,
  load: createFileLoader("json")
}, // text
{
  key: "text",
  match: /\.txt$/i,
  load: createFileLoader("text")
}, // image
{
  key: "image",
  match: /\.(jpg|jpeg|svg|png|gif|webp|bmp|tga|tif|apng|wbpm|ico)$/i,
  load: loadImage
}, // audio
createMediaLoader("audio", function () {
  return new window.Audio();
}), // video
createMediaLoader("video", function () {
  return document.createElement("video");
}), // binary
{
  key: "binary",
  match: /\.bin$/i,
  load: createFileLoader("binary")
}, // blob
{
  key: "blob",
  load: createFileLoader("blob")
}];
export default exports;